import type { GridColumnSettings } from '../grid-column.types';
import { formatPatientCount } from './patient-count.formatter';

/** A column of how many patients something counts, ready to place in any table. */
export function patientCountColumn<TRow>(): GridColumnSettings<TRow> {
    return {
        cellClass: 'ag-right-aligned-cell',
        headerClass: 'ag-right-aligned-header',
        valueFormatter: formatPatientCount,
        filter: 'agNumberColumnFilter',
    };
}
